<template>
	<div class = "whole-viewport">
		<v-toolbar color = "blue-grey lighten-5" class = "index-topbar">
			<v-hover>
				<img slot-scope="{ hover }" src="../assets/logo-fine.png" alt = "music x lab logo" class = "logo"  />
			</v-hover>
      <div style="width: 30px"></div>
			<v-hover>
				<img slot-scope="{ hover }" src="../assets/logo-nyu.png" alt = "music x lab logo" class = "logonyu"/>
			</v-hover>
      <div style="width: 30px"></div>
      <v-hover>
				<img slot-scope="{ hover }" src="../assets/logo-mbzuai.png" alt = "mbzuai logo" class = "logombz"/>
			</v-hover>
    		<!-- <v-toolbar-title>Music X Lab</v-toolbar-title> -->
    		<v-spacer></v-spacer>
    		<v-toolbar-items  style="font-family:'Breve Display';">
      			<v-btn flat :color= "this.$color.primary" style="font-size:1.2rem;" @click =" $router.push({path:'/index'})">Home</v-btn>
      			<v-btn flat :color= "this.$color.primary" style="font-size:1.2rem;"  @click =" $router.push({path:'/people'})">People</v-btn>
				<v-menu offset-y open-on-hover>
					<template v-slot:activator = "{on}">
        				<v-btn color= "#575757" flat v-on = "on" style="font-size:1.2rem;" @click =" $router.push({path:'/groups'})">Groups</v-btn>
					</template>
      				<v-list>
        				<v-list-tile v-for="(item, index) in groupInfo" :key = "index" @click="$router.push({name:'Groups',params:{logan:item.logan}})" >
          					<v-list-tile-title>
								{{ item.name }}
							</v-list-tile-title>
        				</v-list-tile>
      				</v-list>
				</v-menu>
				<v-menu offset-y open-on-hover>
					<template v-slot:activator = "{on}">
        				<v-btn color= "#657C88" flat v-on = "on" style="font-size:1.2rem;">Demos</v-btn>
					</template>
      				<v-list>
        				<v-list-tile v-for="(item, dindex) in demoInfo" :key = "dindex" @click="$router.push({path: item.address})" >
          					<v-list-tile-title >
								{{ item.name }}
							</v-list-tile-title>
        				</v-list-tile>
                        <v-list-tile flat @click="switchToPage('https://www.cs.cmu.edu/~gxia/demo.html')"><v-list-tile-title >Other Demos</v-list-tile-title></v-list-tile>
      				</v-list>
                    
				</v-menu>
				<v-btn :color= "this.$color.activate" flat style="font-size:1.2rem;" @click =" $router.push({path:'/publications'})">Publications</v-btn>
				<v-btn :color= "this.$color.primary" flat style="font-size:1.2rem;" @click =" switchToPage('http://blog.musicxlab.com/') ">Blog</v-btn>
				<v-btn :color= "this.$color.primary" flat style="font-size:1.2rem;" @click =" switchToPage('https://github.com/music-x-lab/music-x-lab') ">Github</v-btn>
				<!-- <v-btn flat>News</v-btn> -->
    		</v-toolbar-items>
  		</v-toolbar>
		<v-layout row wrap style = "background:url('https://ws2.sinaimg.cn/large/006Xmmmggy1g6s2iiwwqbj33340nmkjl.jpg');" class = "elevation-1">
            <v-flex xs12 class="text-xs-center pt-4 ">
                <div class = "mb-2" :style = "{color:this.$color.primary,fontSize:5.0 + 'rem',fontFamily:'Calluns !important'}">Publications</div>
                <div class = "display-1 mb-4" style="color:grey">文章岂能尽心意 下笔已是第二乘</div>
            </v-flex>
        </v-layout>
        <v-layout row wrap class = "pt-3" >
            <v-flex xs3></v-flex>
            <v-flex xs7 class = "text-xs-left">
                <div>
                 <div v-for="(group,gid) in groupInfo.slice(0,3)"  :key="gid" class = "v-btn__content my-1 mx-2" style="display:inline;justify-content:left;font-family:Circular;">
                    <v-btn :key="gid" :color="group.logan" fab v-on="on" small></v-btn>    
                    <span class ="subheading" :key="gid">{{group.name}}</span>
                 </div>
                </div>
            </v-flex>
            <v-flex xs2></v-flex>
        </v-layout>
        <v-layout row wrap class = "pt-2" >
            <v-flex xs3></v-flex>
            <v-flex xs7  class = "text-xs-left">
                 <div v-for="(group,gid) in groupInfo.slice(3)" :key="gid" class = "v-btn__content my-1 mx-2" style="display:inline;justify-content:left;font-family:Circular;">
                    <v-btn :key="gid" :color="group.logan" fab v-on="on" small></v-btn>    
                    <span class ="subheading" :key="gid">{{group.name}}</span>
                 </div>
            </v-flex>
            <v-flex xs2></v-flex>
        </v-layout>
        <v-divider class = "mt-3"></v-divider>
        <v-layout row wrap class = "pt-2">
            <v-flex xs2></v-flex>
            <v-flex xs8 class = "text-xs-center">
                <v-list two-line expand class = "limit__height__class" style = "height:100px;" >
                    <template v-for="(item, index) in publications"  id = "paper-title">
                        <v-list-tile :key="item.title" ripple class = "mx-5">
                            <v-list-tile-content v-bind:id="item.name.replaceAll(' ', '')" style = "height:auto;">
                                <v-list-tile-title class = "mt-3 py-1" :style="{height:'auto',fontSize:1.7 + 'rem',color:$color.activate}"  >
                                    <v-tooltip top :key="item.title" attach="paper-title" class = "limit-title-offset">
                                        <template v-slot:activator="{on}"> 
                                          <span v-on="on">{{ item.name }}</span>
                                        </template>
                                        <span >{{ item.name }}</span>
                                    </v-tooltip>   
                                   
                                </v-list-tile-title>
                                <v-list-tile-sub-title class = "text--primary my-1 " :style="{height:'auto',fontSize:1.3 + 'rem',color:$color.primary}">
                                    <template  v-for="(author,au_id) in item.authors" >
                                        <span style="mr-2" :key="au_id">
                                            {{ author + (parseInt(au_id) + 1 < Object.keys(item.authors).length ? ',':' ')}}
                                        </span>
                                    </template>
                                    </v-list-tile-sub-title>
                                <v-list-tile-sub-title class = "pb-1" :style="{height:'auto',fontSize:1.1 + 'rem',color:$color.primary}">{{ item.conference + ' ' + item.year }}</v-list-tile-sub-title>
                                <v-list-tile-sub-title class = "mb-3 pb-1" :style="{height:'auto',fontSize:1.1 + 'rem',color:$color.primary}">
                                    <div class = "v-btn__content" style="justify-content:left;">
                                        <v-icon>link</v-icon>
                                        <template v-for="(rl,rl_id) in resourceList" >
                                            <a v-if="item[rl] != ''" :key="rl_id" class = "ml-1" :href="item[rl]" :style="{color:$color.activate} ">
                                                {{rl}}
                                            </a>
                                            <span v-else :key="rl_id" class = "ml-1"> 
                                                {{rl}}
                                            </span>
                                            <span class = "ml-1">
                                                {{(parseInt(rl_id) + 1 < Object.keys(resourceList).length ? ' | ':' ')}}
                                            </span>
                                        </template>
                                    </div>
                                    
                                    
                                </v-list-tile-sub-title>
                            </v-list-tile-content>
                            <v-list-tile-action>
                            </v-list-tile-action>
                            <template v-for="(group,gid) in item.color">
                                <v-tooltip top :key="index * gid" attach = "#paper-title" class = "limit-logan-offset">
                                    <template v-slot:activator="{on}">
                                        <v-btn :color="group[1]" fab v-on="on" style="height:25px;width:25px;"></v-btn>
                                    </template>
                                    <span>{{group[0]}}</span>
                                </v-tooltip>   
                            </template>
                        </v-list-tile>
                        <v-divider v-if="index + 1 < publications.length" :key="index"></v-divider>
                    </template>
                </v-list>
            </v-flex>
            <v-flex xs2></v-flex>
        </v-layout>

	</div>
</template>

<script>
export default {
  name: 'Publications',
  data() {
    return {
        resourceList:["pdf","code","demo","video"],
        publications:[{name:"",authors:[],year:"",conference:"",bibtex:"",pdf:"",code:"",demo:"",color:[],video:""}],
        sscolor:"#575757",
        groupInfo:[{name:"",
					introPic:"",
					intro:"",
					description:"",
					logan:""
                    }],
        demoInfo:[
            {name:"Interactive Rainbow Score", address:"/demo/IRS"}
        ]
    }
  },
  mounted() {
      this.getPublicationInfo()
      
  },
  props: {
    msg: String
  },
  methods: {
    switchToPage:function(url) {
		window.location.href=url
	},
    getPublicationInfo:async function() {
        let that = this
        await this.$axios.get("/group/id/list").then(function(res) {
			that.groupInfo = []
			for(let i in res.data) {
				that.groupInfo.push({
					name:res.data[i].name,
					intro:res.data[i].intro,
					introPic:res.data[i].picture,
					description:res.data[i].keywords,
					logan:res.data[i].color
				})
            }
            console.log(that.groupInfo)
		}).catch(function(error) {
			console.log(error)
		})
        await this.$axios.get("/publication/id/list").then(function(res) {
            that.publications = res.data
            for(let i in that.publications) {
                that.publications[i].groups = that.groupInfo
                that.publications[i].bibtex = "@/" + that.publications[i].bibtex
            }
            that.publications.reverse()
            console.log(that.publications)
		}).catch(function(error) {
			console.log(error)
		})
    }
    
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->

<style>
.limit__height__class .v-list__tile {
    height: inherit !important;
}
.limit-logan-offset .v-tooltip__content {
    top:1px !important;
}

.limit-title-offset .v-tooltip__content {
    top:0px !important;
}
</style>
